export default {
  data() {
    return {
      imgUrl: this.imgUrl
    }
  },
  methods: {
    // 计算状态
    state(start_stydy_time, end_study_time) {
      let stydy = new Date(start_stydy_time).getTime()
      let end = new Date(end_study_time).getTime()
      let time = new Date().getTime()
      if (time > end) {
        return "已完成"
      } else if (time < end && time > stydy) {
        return "学习中"
      } else {
        return "报名中"
      }
    },
    //跳转项目包主页
    toProjectHomePage(id) {
      this.$router.push({
        path: "/pojecthomepage",
        query: {
          id: id
        }
      })
    },
  },
  props: {
    course: Object
  },
  mounted(){
    // // console.log('怎么',this.course);
  }
}